import React, { useContext, useState } from 'react'
import { UserAuth } from '../Context/AuthContext'
import { useNavigate } from 'react-router-dom'
import { UserIDContext, UserIDUpdateContext, UserTypeContext, UserTypeUpdateContext } from '../Context/UserContext'
import { Spinner } from 'flowbite-react'
import axios from "axios"
export default function Login() {
    const baseURL="https://mukti-backend-bd.onrender.com"
    const [email,setEmail]=useState("")
    const [password,setPassword]=useState("")
    const [loggingIn,setLogggingIn]=useState(false)
    const userTypeChange=useContext(UserTypeUpdateContext)
    const userIDChange=useContext(UserIDUpdateContext)
    const navigator= useNavigate()

    const { signIn,user } = UserAuth();
    const handleSubmit =async () => {
        try{
          setLogggingIn(true)
          await signIn(email, password)
          const siteUser= await axios.get(`${baseURL}/user/${email}`)
          console.log(siteUser.data)
          await userTypeChange(siteUser.data.user_type)
          await userIDChange(siteUser.data.user_id)
          navigator("/")
          
          
        }
        catch(e){
          console.log(e)
          setLogggingIn(false)
        }
        finally{
          setLogggingIn(false)
        } 
    }
  return (
    <div className='min-h-screen bg-gray-50 dark:bg-gray-900'>
        <section class="bg-gray-50 dark:bg-gray-900">
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <a href="#" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
         
          Mukti Bangladesh   
      </a>
      <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Sign in to your account
              </h1>
              <form class="space-y-4 md:space-y-6" action="#">
                  <div>
                      <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your email</label>
                      <input type="email" name="email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-pink-600 focus:border-pink-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required="" onChange={e=>setEmail(e.target.value)}/>
                  </div>
                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input type="password" name="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-pink-600 focus:border-pink-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required="" onChange={e=>setPassword(e.target.value)}/>
                  </div>
                  <div class="flex items-center justify-between">
                      <div class="flex items-start">
                          <div class="flex items-center h-5">
                            <input id="remember" aria-describedby="remember" type="checkbox" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-pink-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-pink-600 dark:ring-offset-gray-800" required=""/>
                          </div>
                          <div class="ml-3 text-sm">
                            <label for="remember" class="text-gray-500 dark:text-gray-300">Remember me</label>
                          </div>
                      </div>
                      <a href="#" class="text-sm font-medium text-pink-600 hover:underline dark:text-pink-500">Forgot password?</a>
                  </div>
                 {!loggingIn && <button type="submit" class="w-full text-white bg-pink-600 hover:bg-pink-700 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-pink-600 dark:hover:bg-pink-700 dark:focus:ring-pink-800" onClick={handleSubmit}>Sign in</button>}
                 {loggingIn && <div style={{display:"flex",alignItems:'center'}}><Spinner/><h2 sx={{marginLeft:"10px"}}>Signing In</h2></div>}
                 <button type="submit" class="w-full text-white bg-pink-600 hover:bg-pink-700 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-pink-600 dark:hover:bg-pink-700 dark:focus:ring-pink-800" onClick={()=>navigator('/')}>View As Guest</button>
                  <p class="text-sm font-light text-gray-500 dark:text-gray-400">
                      Don’t have an account yet? <a href="#" class="font-medium text-pink-600 hover:underline dark:text-pink-500">Sign up</a>
                  </p>
              </form>
          </div>
      </div>
  </div>
</section>
    </div>
  )
}
